// @flow
import React from 'react';

import { ESTIMATE_COMMIT_DETAILS_CONFIG_MAP } from '../../configuration/estimate-commit-details';
import { COMMITTED_CAPACITY_ENABLED_BACKEND_NAME } from '../../constants';
import { BooleanSelectField } from '../../formik-utils/FormFields';

export const CommittedCapacityEnabledContainer = () => {
  const committedCapacityEnabledConfig = ESTIMATE_COMMIT_DETAILS_CONFIG_MAP.get(
    COMMITTED_CAPACITY_ENABLED_BACKEND_NAME
  );

  return (
    <BooleanSelectField
      fieldDisplayName={committedCapacityEnabledConfig.displayName}
      fieldName={committedCapacityEnabledConfig.backendFieldName}
    />
  );
};
